import angular from 'angular';
import uiRouter from 'angular-ui-router';
import datatableComponent from './datatable.component';
import datatableService from './datatable.service';

let datatableModule = angular.module('datatable', [
  uiRouter
])

.component('datatable', datatableComponent)
.service('datatableService', datatableService)

.name;

export default datatableModule;



// WEBPACK FOOTER //
// ./client/app/common/datatable/datatable.js